import * as React from "react";
import { isEqual } from "lodash";
import { Grid } from "../../core/Grid";
import {
  IXGridProps,
  TXGridProps,
} from "../../../utils/interfaces/containers/XGrid.interfaces";
import { TUseXElement, useXElementValue } from "../../../hooks/useXElement";

import XArticleProvider from "../../../context/XArticleProvider";
import XArticle from "../../common/XArticle";
import { TCoreXElement } from "../../../utils/types/core/CoreXelement";
import { useArticles } from "../../../hooks/useArticles";
import { Skeleton } from "@mui/material";
import { TColumns } from "../../../utils/types/containers/XGrid.types";

const compareProps = (prevProps: any, nextProps: any) => {
  return isEqual(prevProps, nextProps);
};

const XGridCore: TCoreXElement<IXGridProps> = ({
  index,
  props,
  DynamicXElement,
}) => {
  // WE ARE GETTING THE CURRENT ELEMENT FROM THE ATOM FAMILY
  const xElement = useXElementValue<TUseXElement<TXGridProps>>(index);

  const { articles } = useArticles({ limit: 8, ...xElement.dataFetching });

  const { columns = 3, gap = "10px" } = props;

  let elements = DynamicXElement
    ? xElement.elementsIndexes.map((id, p) => (
        <DynamicXElement
          key={id}
          index={id}
          hierachy={xElement.hierachy}
          child={null}
          position={p}
        />
      ))
    : [];

  if (articles && xElement.dataFetching && xElement.dataFetching.enabled) {
    elements = articles.map((article, i) => {
      const id = article.id ?? i.toString();

      return (
        <XArticleProvider data={article} key={id}>
          <XArticle index={id} />
        </XArticleProvider>
      );
    });
  }

  return (
    <Grid
      columns={columns}
      gap={gap}
      height="100%"
      width="100%"
      rowSpan={props.rowSpan as TColumns}
      colSpan={props.colSpan as TColumns}
    >
      {elements}
      {elements.length === 0 && [
        ...Array(columns)
          .fill("col")
          .map((_, index) => (
            <Skeleton width="100%" height={300} key={index.toString()} />

            // <Stack
            //   height={256}
            //   width="100%"
            //   bgcolor={MAIN_COLOR}
            //   alignItems="center"
            //   justifyContent="center"
            //   key={index.toString()}
            //   boxShadow={`0 10px 30px -15px ${MAIN_COLOR}`}
            //   my={3}
            //   boxSizing="border-box"
            // >
            //   <Typography
            //     variant="h3"
            //     component="p"
            //     sx={{
            //       fontSize: 25,
            //       letterSpacing: 1,
            //       fontFamily: "monospace",
            //       color: "white",
            //       fontWeight: 700,
            //     }}
            //   >
            //     {index + 1}
            //   </Typography>
            // </Stack>
          )),
      ]}
    </Grid>
  );
};

export default React.memo(XGridCore, compareProps);
